/* Full PDP runtime. Quick-add keeps the native live product-info. */
  (function () {
    var status = document.querySelector('[data-klaim-stock-status]');
    var mapNode = document.querySelector('[data-klaim-stock-map]');
    if (!status || !mapNode || status.dataset.klaimStockReady === 'true') return;
    status.dataset.klaimStockReady = 'true';

    var stockMap;
    try {
      stockMap = JSON.parse(mapNode.textContent);
    } catch (error) {
      stockMap = {};
    }

    function renderStock(variantId) {
      var stock = stockMap[String(variantId)];
      if (!stock) return;
      status.innerHTML = [
        stock.amsterdam ? '<span class="klaim-pdp-flaneur__stock-line">IN STOCK AT AMSTERDAM STORE</span>' : '',
        stock.online ? '<span class="klaim-pdp-flaneur__stock-line">IN STOCK ONLINE</span>' : '',
        !stock.amsterdam && !stock.online ? '<span class="klaim-pdp-flaneur__stock-line">SOLD OUT</span>' : ''
      ].join('');
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (variant && variant.id) renderStock(variant.id);
      });
    }

    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || input.name !== 'id' || !input.value) return;
      renderStock(input.value);
    });
  })();

  (function () {
    var variants = document.querySelector('[data-klaim-mobile-size]');
    if (!variants || variants.dataset.klaimMobileSizeReady === 'true') return;
    variants.dataset.klaimMobileSizeReady = 'true';

    var toggle = variants.querySelector('.klaim-pdp-flaneur__mobile-size-toggle');
    var label = variants.querySelector('[data-klaim-mobile-size-label]');
    var content = variants.querySelector('.klaim-pdp-flaneur__variants-content');
    if (!toggle || !label || !content) return;

    function revealSelectedSize() {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          if (!variants.classList.contains('is-open')) return;
          var optionLabels = content.querySelectorAll('input[type="radio"] + label');
          var naturalHeight = content.scrollHeight;
          if (optionLabels.length) {
            var firstOptionRect = optionLabels[0].getBoundingClientRect();
            var lastOptionRect = optionLabels[optionLabels.length - 1].getBoundingClientRect();
            naturalHeight = Math.ceil(lastOptionRect.bottom - firstOptionRect.top);
          }
          document.documentElement.style.setProperty('--klaim-pdp-size-list-height', naturalHeight + 'px');
          if (content.scrollHeight <= content.clientHeight) return;

          var currentSize = label.textContent.trim().replace(/^Size\s*/i, '');
          var selectedLabel = Array.prototype.find.call(
            content.querySelectorAll('input[type="radio"] + label'),
            function (optionLabel) {
              var optionText = optionLabel.querySelector('.variant-label--text');
              return optionText && optionText.textContent.trim() === currentSize;
            }
          );
          if (!selectedLabel) {
            var checked = content.querySelector('input[type="radio"]:checked');
            selectedLabel = checked && checked.labels && checked.labels[0];
          }
          if (!selectedLabel) return;

          var contentRect = content.getBoundingClientRect();
          var selectedRect = selectedLabel.getBoundingClientRect();
          var target = content.scrollTop
            + selectedRect.top
            - contentRect.top
            - ((content.clientHeight - selectedRect.height) / 2);
          content.scrollTop = Math.max(0, Math.min(target, content.scrollHeight - content.clientHeight));
        });
      });
    }

    toggle.addEventListener('click', function () {
      var open = variants.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      if (open) revealSelectedSize();
    });

    content.addEventListener('change', function (event) {
      if (!event.target.matches('input[type="radio"]')) return;
      var selected = content.querySelector('input[type="radio"]:checked + label .variant-label--text');
      if (selected) label.textContent = selected.textContent.trim();
      variants.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    });
  })();

  (function () {
    var root = document.querySelector('[data-klaim-pdp-flaneur]');
    if (!root || root.dataset.klaimMysteryAssetReady === 'true') return;
    root.dataset.klaimMysteryAssetReady = 'true';

    var title = (root.dataset.klaimProductTitle || '').toLowerCase();
    if (title.indexOf('mystery box') === -1) return;

    var asset = title.indexOf('sneaker') !== -1
      ? root.dataset.klaimSneakerMysteryAsset
      : root.dataset.klaimMysteryBoxAsset;
    if (!asset) return;

    var firstImage = root.querySelector('[data-klaim-gallery] #SlidesCon > .product-media-image:first-child img');
    if (!firstImage) return;
    firstImage.src = asset;
    firstImage.srcset = asset;
    firstImage.removeAttribute('sizes');

    var firstThumbnail = root.querySelector('[data-klaim-gallery] .gallery-slider--thumbnail[data-slide-index="1"] img');
    if (firstThumbnail) {
      firstThumbnail.src = asset;
      firstThumbnail.srcset = asset;
      firstThumbnail.removeAttribute('sizes');
    }
  })();

  (function () {
    var root = document.querySelector('[data-klaim-pdp-flaneur]');
    if (!root || root.dataset.klaimInitialViewportReady === 'true') return;
    root.dataset.klaimInitialViewportReady = 'true';

    function alignMobileViewport() {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      var gallery = root.querySelector('[data-klaim-gallery]');
      if (!gallery) return;

      var sticky = root.querySelector('.klaim-sticky-atc');
      var galleryBottom = gallery.getBoundingClientRect().bottom;
      var stickyHeight = sticky ? sticky.getBoundingClientRect().height : 96;
      /* Load with the gallery progress edge directly above the fixed purchase bar. */
      var targetScroll = Math.max(0, window.scrollY + galleryBottom - window.innerHeight + stickyHeight);
      if (Math.abs(window.scrollY - targetScroll) > 4) {
        window.scrollTo({ top: targetScroll, left: 0, behavior: 'auto' });
      }
    }

    if (document.readyState === 'complete') {
      window.setTimeout(alignMobileViewport, 250);
    } else {
      window.addEventListener('load', function () {
        window.setTimeout(alignMobileViewport, 250);
      }, { once: true });
    }
  })();

  (function () {
    var root = document.querySelector('[data-klaim-pdp-flaneur]');
    var modal = document.querySelector('[data-klaim-notify-modal]');
    var mapNode = document.querySelector('[data-klaim-stock-map]');
    if (!root || !modal || !mapNode || root.dataset.klaimNotifyReady === 'true') return;
    if (root.dataset.specialPurchase === 'true' || root.dataset.bundlePurchase === 'true') return;
    root.dataset.klaimNotifyReady = 'true';

    var stockMap;
    try {
      stockMap = JSON.parse(mapNode.textContent);
    } catch (error) {
      stockMap = {};
    }

    var form = modal.querySelector('[data-klaim-notify-form]');
    var emailInput = modal.querySelector('[data-klaim-notify-email]');
    var submitButton = modal.querySelector('[data-klaim-notify-submit]');
    var errorMessage = modal.querySelector('[data-klaim-notify-error]');
    var successMessage = modal.querySelector('[data-klaim-notify-success]');
    var optionMessage = modal.querySelector('[data-klaim-notify-option]');
    var activeVariantId = '';
    var lastFocus = null;
    var pageLock = null;

    function saveStyle(element, property) {
      return {
        value: element.style.getPropertyValue(property),
        priority: element.style.getPropertyPriority(property)
      };
    }

    function restoreStyle(element, property, saved) {
      if (saved.value) element.style.setProperty(property, saved.value, saved.priority);
      else element.style.removeProperty(property);
    }

    function lockPage() {
      if (pageLock) return;
      var html = document.documentElement;
      var body = document.body;
      var scrollY = window.scrollY || window.pageYOffset || 0;
      pageLock = {
        scrollY: scrollY,
        htmlOverflow: saveStyle(html, 'overflow'),
        bodyPosition: saveStyle(body, 'position'),
        bodyTop: saveStyle(body, 'top'),
        bodyLeft: saveStyle(body, 'left'),
        bodyRight: saveStyle(body, 'right'),
        bodyWidth: saveStyle(body, 'width'),
        bodyOverflow: saveStyle(body, 'overflow')
      };
      html.classList.add('klaim-pdp-notify-open');
      body.classList.add('klaim-pdp-notify-open');
      html.style.setProperty('overflow', 'hidden', 'important');
      body.style.setProperty('position', 'fixed', 'important');
      body.style.setProperty('top', '-' + scrollY + 'px', 'important');
      body.style.setProperty('left', '0', 'important');
      body.style.setProperty('right', '0', 'important');
      body.style.setProperty('width', '100%', 'important');
      body.style.setProperty('overflow', 'hidden', 'important');
    }

    function unlockPage() {
      if (!pageLock) return;
      var html = document.documentElement;
      var body = document.body;
      var saved = pageLock;
      pageLock = null;
      html.classList.remove('klaim-pdp-notify-open');
      body.classList.remove('klaim-pdp-notify-open');
      restoreStyle(html, 'overflow', saved.htmlOverflow);
      restoreStyle(body, 'position', saved.bodyPosition);
      restoreStyle(body, 'top', saved.bodyTop);
      restoreStyle(body, 'left', saved.bodyLeft);
      restoreStyle(body, 'right', saved.bodyRight);
      restoreStyle(body, 'width', saved.bodyWidth);
      restoreStyle(body, 'overflow', saved.bodyOverflow);
      window.scrollTo(0, saved.scrollY);
    }

    function getCurrentVariantId() {
      var hiddenInput = root.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (hiddenInput && stockMap[String(hiddenInput.value)]) return String(hiddenInput.value);
      var selectedVariant = root.querySelector('[data-selected-variant]');
      if (selectedVariant) {
        try {
          var parsed = JSON.parse(selectedVariant.textContent);
          if (parsed && stockMap[String(parsed.id)]) return String(parsed.id);
        } catch (error) {}
      }
      return '';
    }

    function getVariantForInput(input) {
      var picker = input && input.closest('variant-selects');
      if (!picker) return null;
      var options = Array.prototype.map.call(picker.querySelectorAll('fieldset'), function (fieldset) {
        if (fieldset.contains(input)) return input.value;
        var checked = fieldset.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : '';
      });
      var ids = Object.keys(stockMap);
      for (var index = 0; index < ids.length; index += 1) {
        var variant = stockMap[ids[index]];
        if (!variant || !Array.isArray(variant.options)) continue;
        var matches = variant.options.length === options.length && variant.options.every(function (value, optionIndex) {
          return String(value) === String(options[optionIndex]);
        });
        if (matches) return { id: ids[index], data: variant };
      }
      return null;
    }

    function resetModal() {
      form.hidden = false;
      successMessage.hidden = true;
      errorMessage.hidden = true;
      errorMessage.textContent = '';
      submitButton.disabled = false;
      submitButton.removeAttribute('aria-busy');
      submitButton.textContent = 'NOTIFY ME';
    }

    function openModal(variantId, trigger) {
      var variant = stockMap[String(variantId)];
      if (!variant || variant.online) return;
      activeVariantId = String(variantId);
      lastFocus = trigger || document.activeElement;
      resetModal();
      var option = Array.isArray(variant.options)
        ? variant.options.filter(function (value) { return value && value !== 'Default Title'; }).join(' / ')
        : '';
      optionMessage.textContent = option ? ' in ' + option : '';
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('is-open');
      if ('inert' in modal) modal.inert = false;
      lockPage();
      window.requestAnimationFrame(function () { emailInput.focus(); });
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      if ('inert' in modal) modal.inert = true;
      modal.hidden = true;
      unlockPage();
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    function syncCtas() {
      var variant = stockMap[getCurrentVariantId()];
      var unavailable = Boolean(variant && !variant.online);
      var stickyButton = root.querySelector('.klaim-sticky-atc__button');
      var stickyLabel = stickyButton && stickyButton.querySelector('.klaim-sticky-atc__button-label');
      var stickyPrice = stickyButton && stickyButton.querySelector('.klaim-sticky-atc__button-price');
      var desktopButton = root.querySelector('[data-klaim-desktop-add]');
      if (stickyButton) stickyButton.dataset.klaimNotifyUnavailable = String(unavailable);
      if (desktopButton) desktopButton.dataset.klaimNotifyUnavailable = String(unavailable);
      if (!unavailable) return;
      if (stickyButton) {
        stickyButton.disabled = false;
        stickyButton.removeAttribute('aria-disabled');
      }
      if (desktopButton) {
        desktopButton.disabled = false;
        desktopButton.removeAttribute('aria-disabled');
      }
      if (stickyLabel && stickyLabel.textContent !== 'NOTIFY ME') stickyLabel.textContent = 'NOTIFY ME';
      if (stickyPrice && stickyPrice.textContent !== '') stickyPrice.textContent = '';
      if (desktopButton && desktopButton.firstElementChild && desktopButton.firstElementChild.textContent !== 'NOTIFY ME') {
        desktopButton.firstElementChild.textContent = 'NOTIFY ME';
      }
      if (desktopButton && desktopButton.lastElementChild && desktopButton.lastElementChild.textContent !== '') {
        desktopButton.lastElementChild.textContent = '';
      }
    }

    function decorateUnavailableSizes() {
      root.querySelectorAll('.klaim-pdp-flaneur__variants-content input[type="radio"].disabled').forEach(function (input) {
        var label = root.querySelector('label[for="' + input.id + '"]');
        if (!label || label.dataset.klaimNotifyReady === 'true') return;
        label.dataset.klaimNotifyReady = 'true';
        label.classList.add('klaim-pdp-notify-trigger');
        label.setAttribute('role', 'button');
        label.setAttribute('tabindex', '0');
        var size = (label.querySelector('.variant-label--text') || label).textContent.trim();
        label.setAttribute('aria-label', 'Notify me when size ' + size + ' is available');

        label.addEventListener('click', function () {
          var match = getVariantForInput(input);
          if (!match || match.data.online) return;
          window.setTimeout(function () { openModal(match.id, label); }, 0);
        });

        label.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          if (!input.checked) input.click();
          var match = getVariantForInput(input);
          if (match && !match.data.online) openModal(match.id, label);
        });
      });
    }

    root.addEventListener('click', function (event) {
      var button = event.target.closest('.klaim-sticky-atc__button, [data-klaim-desktop-add]');
      if (!button || button.dataset.klaimNotifyUnavailable !== 'true') return;
      var variantId = getCurrentVariantId();
      if (!variantId) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      openModal(variantId, button);
    }, true);

    root.addEventListener('klaim:notify-variant', function (event) {
      var variantId = event.detail && event.detail.variantId;
      if (!variantId || !stockMap[String(variantId)] || stockMap[String(variantId)].online) return;
      openModal(String(variantId), event.detail.trigger || document.activeElement);
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.closest('[data-klaim-notify-close]')) closeModal();
    });

    document.addEventListener('keydown', function (event) {
      if (!modal.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.filter.call(
        modal.querySelectorAll('button:not([disabled]), input:not([disabled])'),
        function (element) { return !element.hidden && element.offsetParent !== null; }
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = emailInput.value.trim();
      if (!email || !emailInput.checkValidity()) {
        errorMessage.textContent = 'ENTER A VALID EMAIL ADDRESS.';
        errorMessage.hidden = false;
        emailInput.focus();
        return;
      }
      var companyId = root.dataset.klaimKlaviyoCompanyId;
      if (!companyId || !activeVariantId) return;
      errorMessage.hidden = true;
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
      submitButton.textContent = 'SAVING...';

      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          'content-type': 'application/vnd.api+json',
          revision: '2026-07-15'
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email }
                }
              }
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: '$shopify:::$default:::' + activeVariantId
                }
              }
            }
          }
        })
      }).then(function (response) {
        if (!response.ok) throw new Error('Back in stock subscription failed');
        form.hidden = true;
        successMessage.hidden = false;
        modal.querySelector('[data-klaim-notify-close]').focus();
      }).catch(function () {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
        submitButton.textContent = 'NOTIFY ME';
        errorMessage.textContent = 'COULD NOT SAVE YOUR ALERT. TRY AGAIN.';
        errorMessage.hidden = false;
      });
    });

    if ('inert' in modal) modal.inert = true;
    decorateUnavailableSizes();
    syncCtas();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        window.setTimeout(syncCtas, 0);
        window.setTimeout(syncCtas, 160);
      });
    }
    root.addEventListener('change', function (event) {
      if (!event.target.matches('input[type="radio"], select')) return;
      window.setTimeout(syncCtas, 0);
      window.setTimeout(syncCtas, 160);
    });
    new MutationObserver(function () {
      decorateUnavailableSizes();
      syncCtas();
    }).observe(root, { childList: true, subtree: true });
  })();
